/**
 * Каналы уведомлений: список, подключение Telegram, отвязка (BE-165, FE-160).
 *
 * Email в этом файле не отключается ничем: маршрута нет, а сервис отвергает
 * попытку отдельным кодом. Копии писем переговоров — часть услуги, а не
 * рассылка (MVP_PRD §21.6).
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@shared/api/client';
import { queryKeys } from '@shared/api/queryKeys';

import type { NotificationChannels, TelegramLink } from './types';

const BASE = '/negotiations/channels';

export function useNotificationChannels() {
  return useQuery({
    queryKey: queryKeys.notificationChannels(),
    queryFn: () => apiFetch<NotificationChannels>(BASE),
    // Состояние канала меняется извне — подтверждением в боте. Свежесть нужна
    // после возврата на вкладку, поэтому кеш короткий.
    staleTime: 5_000,
    retry: false,
  });
}

/**
 * Выдать одноразовую ссылку подключения.
 *
 * Повторный вызов **заменяет** прежний токен на сервере: две действующие
 * ссылки означали бы, что отозвать первую нечем.
 */
export function useCreateTelegramLink() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch<TelegramLink>(`${BASE}/telegram/link`, { method: 'POST' }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.notificationChannels() });
    },
  });
}

export function useUnlinkTelegram() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch<null>(`${BASE}/telegram`, { method: 'DELETE' }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.notificationChannels() });
    },
  });
}
